// extracted by mini-css-extract-plugin
export default {"sliderWrapper":"styles_sliderWrapper__Nz7W2"};